import BaseAPI from "../api";

const path: string = "/gallery-type";

export class GalleryTypeApi extends BaseAPI {
  static createGalleryType(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static getGalleryTypeDropdown(query?: any): Promise<any> {
    return this.api.get(`${path}/dropdown`, {
      params: { ...query },
    });
  }

  static updateGalleryType(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteGalleryType(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static getGalleryTypeList(query?: any): Promise<any> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }
}